import { FC, useState } from 'react'

import { ConfiguredEntityInitialDataWrapper, ConfiguredEntityProps } from '@pages/ConfiguredEntity'

import { EntityType } from '@types'

export const ConfiguredEntityForDDW: FC<
  Omit<ConfiguredEntityProps, 'entity' | 'onSetEntity'>
> = props => {
  const [entity, setEntity] = useState<EntityType | null>(null)

  const handleSetEntity = (value: EntityType | null) => setEntity(value)

  return (
    <ConfiguredEntityInitialDataWrapper {...props} entity={entity} onSetEntity={handleSetEntity} />
  )
}
